import React, { useState } from 'react'
import { IconType } from 'react-icons'
import { Icon } from '@chakra-ui/icons'
import { Collapse } from '@chakra-ui/react'
import { Box, Flex, Spacer, Text } from '@chakra-ui/react'

import SharedStack from '~components/shared/wrappers/shared-stack'
import { FaAngleDown } from 'react-icons/fa6'

interface Props {
    icon: IconType
    title: string
    defaultOpen?: boolean
    children: React.ReactNode
    isOpenState?: boolean
    setIsOpenState?: (isOpen: boolean) => void
}

export default function ChatInfoAccordionItem({
    icon,
    title,
    defaultOpen,
    children,
    isOpenState,
    setIsOpenState,
}: Props) {
    const [isOpen, setIsOpen] = useState<boolean>(defaultOpen ?? false)

    const isOpenToUse = isOpenState ?? isOpen
    const setIsOpenToUse = setIsOpenState ?? setIsOpen

    return (
        <Box borderBottomWidth={1} borderColor="gray.100">
            <Flex
                py={3}
                px={5}
                flexDir="row"
                alignItems="center"
                cursor="pointer"
                onClick={() => setIsOpenToUse(!isOpenToUse)}
                _hover={{
                    bg: 'gray.50',
                }}
                _active={{
                    bg: 'gray.100',
                }}
                transition="0.2s"
                color={isOpenToUse ? 'brand.600' : 'gray.900'}
            >
                <SharedStack row fit spacing={3}>
                    <Icon as={icon} fontSize="13px" />
                    <Text fontSize="sm" fontWeight="semibold">
                        {title}
                    </Text>
                </SharedStack>
                <Spacer />
                <Icon
                    as={FaAngleDown}
                    fontSize="sm"
                    transition="0.2s"
                    transform={isOpenToUse ? 'rotate(-180deg)' : 'rotate(0deg)'}
                />
            </Flex>
            <Box as={Collapse} in={isOpenToUse} maxH="512px" overflowY="scroll">
                {children}
            </Box>
        </Box>
    )
}
